import { render, staticRenderFns } from "./ImpressionsAddress.vue?vue&type=template&id=b35559d6&scoped=true"
var script = {}
import style0 from "./ImpressionsAddress.vue?vue&type=style&index=0&id=b35559d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35559d6",
  null
  
)

export default component.exports